import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Tips = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M23.324.992a.992.992 0 1 0-1.985 0V3.64a.992.992 0 1 0 1.985 0V.992ZM38.777 6.796c.45.314.559.933.245 1.382l-1.517 2.169a.992.992 0 1 1-1.627-1.138l1.517-2.169a.992.992 0 0 1 1.382-.244ZM6.495 7.569A.992.992 0 1 0 5.09 8.972l1.872 1.872A.992.992 0 1 0 8.366 9.44L6.495 7.57Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.755 19.157c0-6.226 5.216-11.217 11.576-11.217h.001c6.36 0 11.576 4.99 11.576 11.217 0 3.11-1.305 5.92-3.404 7.946-1.68 1.622-2.044 3.381-2.4 5.101-.054.257-.107.512-.164.765a.992.992 0 0 1-.968.775h-9.28a.993.993 0 0 1-.968-.774 46.72 46.72 0 0 1-.164-.767c-.357-1.72-.722-3.479-2.401-5.1-2.099-2.027-3.404-4.836-3.404-7.946ZM22.33 9.925c-5.33 0-9.592 4.166-9.592 9.232 0 2.54 1.063 4.842 2.798 6.518 2.113 2.04 2.614 4.37 2.961 6.084h7.668c.347-1.714.847-4.044 2.96-6.084 1.735-1.676 2.798-3.979 2.798-6.518 0-5.066-4.262-9.232-9.592-9.232h-.001Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M26.962 39.203v-2.481h-9.261v2.481c0 3.308 1.984 4.797 4.63 4.797 2.647 0 4.631-1.985 4.631-4.797Z"
  }));
});
Tips.displayName = 'Tips';
Tips.defaultProps = {
  'aria-label': 'Tips'
};
export default Tips;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Tips.js
// module id = 3935
// module chunks = 11